import React, { useEffect } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import Filter from "./Section/Filter";
import { ProductGroupTable } from "./Section/product-group-table";
import TitlePage from "../../../components/section/TitlePage/Titlepage";
import { useNavigate } from "react-router-dom";
import Tabs, { Tablist } from "../../../components/ui/Tabs/Tabs";
import { useSetState } from "../../../utils/hooks";
import Loading from "../../../components/ui/Loading/Loading";

const tabs = [
  {
    title: "전체",
    id: 1,
  },
  {
    title: "정상",
    id: 2,
  },
  {
    title: "판매종료",
    id: 3,
  },
];

function ProductGroupPage() {
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = React.useState(1);
  const [selectedFilter, setSelectedFilter] = React.useState({});
  const [submittedFilter, setSubmittedFilter] = React.useState({});
  const [searchBy, setSearchBy] = React.useState("name");
  const [searchByValue, setSearchByValue] = React.useState("");
  const [sortFilter, setSortFilter] = React.useState({});
  const [isResetted, setIsResetted] = React.useState(false);
  const [isResetting, setIsResetting] = React.useState(false);
  const [isResettedPage, setIsResettedPage] = React.useState(false);
  const filters = { ...submittedFilter, ...sortFilter };
  const resettedFilter = { ...sortFilter };
  const onChangeSearchBy = (id) => {
    setSearchBy(id);
  };
  const onChangeTab = (id) => {
    setCurrentTab(id);
  };
  const onClickAdd = () => {
    navigate("/product-management/registration");
  };

  const onSubmitFilter = () => {
    setIsResettedPage(true);
    setIsResetted(false);
    setSubmittedFilter({
      ...selectedFilter,
      [searchBy]: searchByValue,
    });
  };

  const onResetFilter = () => {
    setSelectedFilter({});
    setSubmittedFilter({});
    setSearchByValue("");
    setIsResetting(true);
    setIsResetted(true);
  };

  useEffect(() => {
    if (isResetting) {
      setTimeout(() => {
        setIsResetting(false);
      }, 500);
    }
  }, [isResetting]);

  useEffect(() => {
    if (isResettedPage) {
      setTimeout(() => {
        setIsResettedPage(false);
      }, 200);
    }
  }, [isResettedPage]);

  const onChangeSearchByValue = (value) => {
    setSearchByValue(value);
  };

  return (
    <>
      <div>
        <TitlePage
          title="상품조회"
          icon={<AiOutlinePlus />}
          buttonText="상품등록"
          onClick={onClickAdd}
        />
        {isResetting ? (
          <Loading />
        ) : (
          <>
            {isResetted ? (
              <Filter
                onSubmitFilter={onSubmitFilter}
                filter={selectedFilter}
                onFilter={setSelectedFilter}
                onResetFilter={onResetFilter}
                onChangeSearchBy={onChangeSearchBy}
                onChangeSearchByValue={onChangeSearchByValue}
              />
            ) : (
              <Filter
                onSubmitFilter={onSubmitFilter}
                filter={selectedFilter}
                onFilter={setSelectedFilter}
                onResetFilter={onResetFilter}
                onChangeSearchBy={onChangeSearchBy}
                onChangeSearchByValue={onChangeSearchByValue}
              />
            )}
          </>
        )}
        <Tabs
          tabWidth="w-20"
          onChangeTab={onChangeTab}
          currentTab={currentTab}
          tabs={tabs}
        >
          <Tablist currentTab={currentTab} index={1}>
            <ProductGroupTable
              onSort={setSortFilter}
              isResettedPage={isResettedPage}
              filter={isResetted ? resettedFilter : filters}
            />
          </Tablist>
          <Tablist currentTab={currentTab} index={2}>
            <ProductGroupTable
              onSort={setSortFilter}
              isResettedPage={isResettedPage}
              filter={
                isResetted
                  ? { ...resettedFilter, saleStatus: "SALE" }
                  : { ...filters, saleStatus: "SALE" }
              }
            />
          </Tablist>
          <Tablist currentTab={currentTab} index={3}>
            <ProductGroupTable
              onSort={setSortFilter}
              isResettedPage={isResettedPage}
              filter={
                isResetted
                  ? { ...resettedFilter, saleStatus: "NOT_SALE" }
                  : { ...filters, saleStatus: "NOT_SALE" }
              }
            />
          </Tablist>
        </Tabs>
      </div>
    </>
  );
}

export default ProductGroupPage;
